import { Component, Input, ViewChild } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faCircleQuestion } from '@ng-icons/font-awesome/regular';
import { ModalComponent } from '../../../components/modal/modal.component';

@Component({
    selector: 'app-stat-card',
    imports: [NgIcon, ModalComponent],
    templateUrl: './stat-card.component.html',
    styleUrl: './stat-card.component.scss',
    providers: [provideIcons({ faCircleQuestion })]
})
export class StatCardComponent {
  @Input()
  title?: string;

  @Input()
  value?: string | number;

  @Input()
  explainer?: string;

  @ViewChild('explainerModal')
  explainerModal!: ModalComponent;

  showExplainerModal() {
    this.explainerModal.toggleModal();
  }
}
